import { createSlice } from '@reduxjs/toolkit';

const initialState = { subscriptionList: [] };

const subscriptionListSlice = createSlice({
  name: 'subscriptionList',
  initialState,
  reducers: {
    subscriptionListHandler(state, action) {
      state.subscriptionList = action.payload.subscriptionListData;
    },
    resetBillingHistory(state) {
      state.billingHistory = null;
    },
  },
});
export const subscriptionListAction = subscriptionListSlice.actions;
export default subscriptionListSlice;